module.exports = __webpack_public_path__ + "static/MarkLennoxSmall-78c36ff6670be13016a644b33f1397f5.png";